import React, { useCallback, useEffect, useState } from "react";
import {getData, postData, postFormData} from '../middleware/apiMiddleware';
import s from './SchoolClass.module.css';
import { useNavigate } from "react-router-dom";
import {RedButton, GreenButton, BlueButton} from './MyButton';
import {modifiedDate} from '../middleware/dateControl';
import {unsecuredCopyToClipboard} from '../middleware/clipboardService';

import strawberryPng from'../asset/strawberry.png';
import MyComponentLoading from '../components/Utilities/MyComponentLoading';
import MyCheckbox, {CheckboxSmall} from '../components/Utilities/MyCheckbox';
import MyPressButton, {MyGreenPressButton} from '../components/Utilities/MyPressButton';

const BatchBindUsersToClasses = ({orgId, fetchClassData, fetchClassDetailData, showDetail}) => {
	const navigate = useNavigate();
	const [errorMessage, setErrorMessage] = useState("")
	const [usernameStr, setUsernameStr] = useState("")
	const [classesStr, setClassesStr] = useState("")
	const [loadingLock, setLoadingLock] = useState(false)
	const [usernameLoaded, setUsernameLoaded] = useState(false)
	const [classLoaded, setClassLoaded] = useState(false)
	const [userObjs, setUserObjs] = useState([])
	
	
	const loadUsername = async () => {		
		setErrorMessage("");
		let newUsername = usernameStr.trim().split(/\r\n|\n|\r/);
		if (newUsername.length == 0) {
			return;
		}
		
		let hasDuplicate = false;
		let duplicateUserName = [];
		let existingName = [];
		for(let nc of newUsername) {
			if (existingName.includes(nc)) {
				hasDuplicate = true;
				duplicateUserName.push(nc);
			} else {
				existingName.push(nc);
			}
		}
		if (hasDuplicate) {
			setErrorMessage("Duplicate User name " + duplicateUserName);
			return;
		}
		
		let obj = { names:newUsername }
		
		let res = await postData("schoolApi/getUserByUsernames", obj, navigate); 
		let data = res.data;
		let nameMap = [];
		let hasInvalidUsers = false;
		let invalidUsers = [];
		for(let d of data) {
			
			if (d.orgIds.includes(orgId)) {
				
			} else {
				hasInvalidUsers = true;
				invalidUsers.push(d.username);
			}
			
			nameMap[d.username.toLowerCase()] = d;
		}
		
		if (hasInvalidUsers) {			
			setErrorMessage("Non-organizational user exists " + invalidUsers.join(','));
			return;
		}
		
		
		let tmpUserObjs = [];
		for(let un of newUsername) {
			let o = {
				id:null,
				username:un,
				classIds:""
			}
			
			let lun = un.toLowerCase();
			if (nameMap[lun] && nameMap[lun].id) {
				o.id = nameMap[lun].id;
			} else {
				hasInvalidUsers = true;
				invalidUsers.push(un);
			}
			
			tmpUserObjs.push(o);
		}
		
		if (hasInvalidUsers) {			
			setErrorMessage("User Not Found " + invalidUsers.join(','));
			return;
		}
		
		
		setUserObjs(tmpUserObjs);
		setUsernameLoaded(true);
	}
	
	const loadClasses = async () => {		
		setErrorMessage("");
		setClassLoaded(false);
		let newClasses = classesStr.trim().split(/\r\n|\n|\r/).map(line => line.replace(/, +/g, ','));
		if (newClasses.length == 0) {
			return;
		}
		
		if (newClasses.length != userObjs.length) {
			setErrorMessage("user X class counting not match");
			return;
		}
	
		let res = await getData('schoolApi/getAllClasses?orgId=' + orgId, navigate);
		
		let classesName = [];
		let classNameMap = new Map();
		for(let d of res.data) {
			classesName.push(d.name);
			classNameMap[d.name] = d;
		}
		let invalidClasses = [];
		for(let nc of newClasses) {
			let cArray = nc.split(',');
			for(let c of cArray) {
				if (classesName.includes(c)) {
					
				} else {
					if (!invalidClasses.includes(c)) {
						invalidClasses.push(c);
					}
				}
			}
		}
		
		if (invalidClasses.length > 0) {
			setErrorMessage("Class not exists: " + invalidClasses.join(','));
			return;
		}
		
		for(let i = 0; i < userObjs.length; i++) {
			userObjs[i].classes = newClasses[i];
			userObjs[i].classIds = newClasses[i].split(',').map(c=>classNameMap[c].id);
		}
		setClassLoaded(true);
	}
	
	const batchBindUserToClass = async () => {
		if (loadingLock) {
			return
		}
		
		if (!(errorMessage == "" && userObjs.length > 0)) {
			setLoadingLock(false);
			return;
		}
		
		let allClassIds = [];
		
		let params = {users:[], orgId};
		for(let u of userObjs) {
			for(let c of u.classIds) {
				params['users'].push(
					{id:u.id, cId:c}
				);
				
				if (!allClassIds.includes(c)) {
					allClassIds.push(c);
				}
			}
		}
		await postData("schoolApi/batchBindUserToClass", params, navigate); 
		
		fetchClassData();
		for(let aci of allClassIds) {
			
			if (showDetail[aci]) {
				fetchClassDetailData(aci);
			}
		}
		
		setErrorMessage("");
		setUsernameStr("");
		setClassesStr("");
		setUsernameLoaded(false);
		setUserObjs([]);
		setLoadingLock(false);		
		setClassLoaded(false);		
	}
	
	return (<div style={{borderBottom:"1px solid #a58258", display:"flex", padding:"0 0 10px 0", flexDirection:"column", gap:"5px"}}>	
		<div className={s.paramHolder}>
			<div style={{fontWeight:"bold", fontSize:"22px"}}>Bind Users to Classes</div>
			
			<div style={{display:"flex", gap:"10px", justifyContent:"center"}}>
				<BlueButton isEnabled={true}
					clickedAction={()=>{
						
						setErrorMessage("");
						setUsernameStr("");
						setClassesStr("");
						setLoadingLock(false);
						setUsernameLoaded(false);
						setUserObjs([]);	
						setClassLoaded(false);	
						
					}} bText={"Reset"} />
				
				{
					(classLoaded) && (<GreenButton isEnabled={!loadingLock}
						clickedAction={()=>{
							setLoadingLock(true);
							batchBindUserToClass();
					}} bText={"Bind!"} />	)
				}
				{
					(!classLoaded) && (<div style={{width:"60px"}}/>	)
				}
			</div>
				
			<div className={s.newLabel} style={{overflowWrap: "break-word"}}>{errorMessage}</div>
			
			<div style={{display:"flex", margin:"10px 0", gap:"10px", justifyContent:"center"}}>
				<div style={{display:"flex", flexDirection:"column", alignItems:"center"}}>
					<div>username</div>
					<textarea style={{border:"1px solid #22222222", minWidth:"200px"}}  
						className={s.textAreaAuto} value={usernameStr} rows={5} wrap='off' onChange={(e) => setUsernameStr(e.target.value)}/>
						
					<div>
						<BlueButton isEnabled={usernameStr}
							clickedAction={()=>{
								loadUsername();
							}} bText="Load" />
					</div>
				</div>
				{
				(usernameLoaded) && (<div style={{display:"flex", flexDirection:"column", alignItems:"center"}}>
						<div>Classes</div>
						<textarea style={{border:"1px solid #22222222", minWidth:"200px"}}  
							className={s.textAreaAuto} value={classesStr} rows={5} wrap='off' onChange={(e) => setClassesStr(e.target.value)}/>
						<div>
							<BlueButton isEnabled={classesStr}
								clickedAction={()=>{
								loadClasses();
								}} bText="Load" />
						</div>
					</div>)
				}			
				{
					(!usernameLoaded) && (<div style={{display:"flex", flexDirection:"column"}}>
						<div style={{minWidth:"230px"}} />
					</div>)
				}
			</div>
		</div>
		
		{userObjs.map((u, indexU)=>(<div key={indexU} style={{textAlign:"left", display:"flex", padding:"0 5px", borderRadius:"5px", margin:"2px 0", gap:"10px"}}>
			<div style={{flexBasis: "100px"}}>{u.id}</div>
			<div style={{flexBasis: "300px"}}>{u.username}</div>
			<div style={{flexBasis: "200px"}}>{u.classes}</div>
		</div>))}
	</div>)
}

const GiveOutMoney = ({orgId}) => {
	const navigate = useNavigate();
	const [classNameStr, setClassNameStr] = useState("")
	const [classObjs, setClassObjs] = useState([])
	const [errorMessage, setErrorMessage] = useState("")
	const [loadingLock, setLoadingLock] = useState(false)

	const loadExistingClassData = async () => {		
		let res = await getData('schoolApi/getAllClasses?orgId=' + orgId, navigate);
		
		let tmpStr = res.data.map(r=>r.name).join("\r\n")
		setClassNameStr(tmpStr)
		
		loadClassData(tmpStr);
	}

	const loadClassData = async (classNameStr) => {
		setErrorMessage("");
		let newClassNames = classNameStr.split(/\r\n|\n|\r/);
		if (newClassNames.length == 0) {
			return;
		}
		
		let hasDuplicate = false;
		let duplicateClassName = [];
		let existingName = [];
		for(let nc of newClassNames) {
			if (existingName.includes(nc)) {
				hasDuplicate = true;
				duplicateClassName.push(nc);
			} else {
				existingName.push(nc);
			}
		}
		let obj = { orgId, names:existingName }
		
		let res = await postData("schoolApi/getClassesByClassNames", obj, navigate); 
		let data = res.data;
		setClassObjs(data);
	}
	
	const [newAddCoin, setNewAddCoin] = useState(0);
	const addNewCoins = async (newAddCoin) => {
		let classIds = classObjs.map(c=> c.id);
		let obj = {coin:newAddCoin, classIds};
		
		await postData("schoolApi/addNewCoins", obj, navigate); 
	}
	const [resetCoin, setResetCoin] = useState(0);
	const updateResetCoin = async (resetCoin) => {
		let classIds = classObjs.map(c=> c.id);
		let obj = {coin:resetCoin, classIds};
		
		await postData("schoolApi/updateResetCoin", obj, navigate); 
	}
	const [newVipExpiryDate, setNewVipExpiryDate] = useState("2024-01-01");
	const updateVipExpiryDate = async (newVipExpiryDate) => {
		let classIds = classObjs.map(c=> c.id);
		let obj = {expiryDate:newVipExpiryDate, classIds};
		
		await postData("schoolApi/updateVipExpiryDate", obj, navigate); 	
	}

	const [newAddDollar, setNewAddDollar] = useState(0);
	const addNewDollar = async (newAddDollar) => {
		let classIds = classObjs.map(c=> c.id);
		let obj = {dollar:newAddDollar, classIds};
		
		await postData("schoolApi/addNewDollar", obj, navigate); 
	
	}
	const [newResetDollar, setNewResetDollar] = useState(0);
	const addResetDollar = async (newResetDollar) => {
		let classIds = classObjs.map(c=> c.id);
		let obj = {dollar:newResetDollar, classIds};
		
		await postData("schoolApi/addResetDollar", obj, navigate); 
	}
	
	return (<div style={{borderBottom:"1px solid #a58258", display:"flex", padding:"0 0 10px 0", flexDirection:"column", gap:"5px"}}>	
		<div className={s.paramHolder}>
			<div style={{fontWeight:"bold", fontSize:"22px"}}>Load Class</div>
			<div className={s.newLabel} style={{overflowWrap: "break-word"}}>{errorMessage}</div>
			<textarea style={{border:"1px solid #22222222", width:"50%"}}  
				className={s.textAreaAuto} value={classNameStr} rows={5} wrap='off' onChange={(e) => setClassNameStr(e.target.value)}/>
		</div>
		
		<div style={{display:"flex", justifyContent:"center", gap:"10px"}}>
			<GreenButton isEnabled={true}
				clickedAction={()=>{
					loadExistingClassData()
				}} bText="Load Existing Classes" />
			<GreenButton isEnabled={classNameStr}
				clickedAction={()=>{
					loadClassData(classNameStr)
				}} bText="Load Class" />
		</div>
		<div className={s.paramHolder} style={{marginTop:0, padding:"5px", width:"100%", display:"flex", alignItems:"center", flexDirection:"row", flexWrap:"wrap", gap:"5px"}}  >	
			{
				(classObjs.length > 0) && (classObjs.map((c, indexC)=> (<div>
					<div style={{background:"#9d723c", borderRadius:"4px", padding:"0 5px", color:"#fdfaf6", fontSize:"18px"}}>{c.id}-{c.name}</div>
				</div>)))
			}
			
			{(classObjs.length == 0) && (<div>Empty...</div>)}
		</div>
		
		{(classObjs.length > 0) &&
		
		(<div className={s.paramHolder} style={{margin:0, padding:"5px", width:"100%", display:"flex", alignItems:"center", flexDirection:"row", flexWrap:"wrap", gap:"2px"}}  >	
			<div className={s.paramHolder} style={{margin:0, padding:"5px", width:"100%", display:"flex", flexWrap:"wrap", gap:"5px"}}  >	
				<div>Add Coins</div>
				<input className={s.inputBox} type="text" value={newAddCoin} 
					onChange={(e)=>{
						setNewAddCoin(e.target.value);
					}}
				/>
				<GreenButton isEnabled={true}
					clickedAction={()=>{
						addNewCoins(newAddCoin);
					}} bText="Add" />
			</div>
			<div className={s.paramHolder} style={{margin:0, padding:"5px", width:"100%", display:"flex", flexWrap:"wrap", gap:"5px"}}  >	
				<div>Reset Coins</div>
				<input className={s.inputBox} type="text" value={resetCoin} 
					onChange={(e)=>{
						setResetCoin(e.target.value);
					}}
				/>
				<GreenButton isEnabled={true}
					clickedAction={()=>{
						updateResetCoin(resetCoin)
					}} bText="Reset" />
					
				<div>Expiry Date</div>
				<input className={s.inputBox} type="text" value={newVipExpiryDate} 
					placeholder="yyyy-mm-dd"
					onChange={(e)=>{
						setNewVipExpiryDate(e.target.value);
					}}
				/>
				
				
				<GreenButton isEnabled={true}
					clickedAction={()=>{
						updateVipExpiryDate(newVipExpiryDate)
					}} bText="Reset" />
			</div>
			<div className={s.paramHolder} style={{margin:0, padding:"5px", width:"100%", display:"flex", flexWrap:"wrap", gap:"5px", alignItems:"center"}}  >	
				<div>Add Dollar</div>
				<img style={{width:"20px", height:"20px"}} src={strawberryPng} />
				
				
				<input className={s.inputBox} type="text" value={newAddDollar} 
					onChange={(e)=>{
						setNewAddDollar(e.target.value);
					}}
				/>
				<GreenButton isEnabled={true}
					clickedAction={()=>{
						addNewDollar(newAddDollar);
					}} bText="Add" />
			</div>
			
			
			
			<div className={s.paramHolder} style={{margin:0, padding:"5px", width:"100%", display:"flex", flexWrap:"wrap", gap:"5px", alignItems:"center"}}  >	
				<div>Reset Dollar</div>
				<img style={{width:"20px", height:"20px"}} src={strawberryPng} />
				<input className={s.inputBox} type="text" value={newResetDollar} 
					onChange={(e)=>{
						setNewResetDollar(e.target.value);
					}}
				/>
				<GreenButton isEnabled={true}
					clickedAction={()=>{
						addResetDollar(newResetDollar);
					}} bText="Reset" />
			</div>
		</div>) }
			
	</div>)
}

const BatchCreateClass = ({orgId, currentYearRange, fetchClassData}) => {
	const navigate = useNavigate();
	const [eduLv, setEduLv] = useState("")
	
	const [classNameStr, setClassNameStr] = useState("")
	const [classObjs, setClassObjs] = useState([])
	const [errorMessage, setErrorMessage] = useState("")
	const [loadingLock, setLoadingLock] = useState(false)
	
	const getEduLv = async () => {
		let res = await getData('schoolApi/getEduLv?id=' + orgId, navigate);
		setEduLv(res.data.eduLv);
	}	
	
	useEffect(() => {
		getEduLv();
	}, []);
	
	if (eduLv == "") {
		return <MyComponentLoading />
	}
	
	
	const sortRemoveDup = async () => {
		// 按换行分割成数组
		const linesArray = classNameStr.split(/\r\n|\n|\r/);
		
		// 处理步骤：
		// 1. 过滤空行
		// 2. 按逗号分割每行内容，修剪空格，过滤空项
		// 3. 扁平化数组（将二维数组转为一维）
		const splitItems = linesArray
			.filter(line => line.trim() !== '') // 移除空行
			.flatMap(line => {
				// 按逗号分割并处理每个项
				return line.split(',')
					.map(item => item.trim()) // 去除每个项前后的空格
					.filter(item => item !== ''); // 过滤分割后可能产生的空字符串
			});
		
		// 去重、排序并拼接成结果字符串
		const uniqueItems = [...new Set(splitItems)];
		uniqueItems.sort();
		const resultString = uniqueItems.join('\n');
		
		setClassNameStr(resultString);
	}
	
	const loadClassData = async () => {
		setErrorMessage("");
		let newClassNames = classNameStr.trim().split(/\r\n|\n|\r/);
		if (newClassNames.length == 0) {
			return;
		}
		
		let hasDuplicate = false;
		let duplicateClassName = [];
		let existingName = [];
		for(let nc of newClassNames) {
			if (existingName.includes(nc)) {
				hasDuplicate = true;
				duplicateClassName.push(nc);
			} else {
				existingName.push(nc);
			}
		}
		if (hasDuplicate) {
			setErrorMessage("Duplicate Class name " + duplicateClassName);
			return;
		}
		
		let obj = { orgId, names:newClassNames }
		
		let res = await postData("schoolApi/getClassesByClassNames", obj, navigate); 
		let data = res.data;
		let classMap = [];
		for(let d of data) {
			classMap[d.name] = d;
		}
		
		let tmpClassObjs = [];
		for(let nc of newClassNames) {
			let o = {
				id:null,
				name:nc,
				label:null,
				level:null				
			}
			
			if (classMap[nc]) {
				o = classMap[nc];
			}
			
			if (!o.label) {
				o.label = currentYearRange;
			}
			
			if (!o.level) {
				const levelNumbers = nc.match(/\d+/g);
				if (levelNumbers) {
					const levelNumber = levelNumbers[0];
					o.level = eduLv.toLowerCase() + levelNumber;
				}
			}
			
			tmpClassObjs.push(o);
		}
		
		setClassObjs(tmpClassObjs);
	}
	
	const batchInsertClasses = async () => {
		if (loadingLock) {
			return
		}
		
		if (!(errorMessage == "" && classObjs.length > 0)) {
			setLoadingLock(false);
			return;
		}
		
		let obj = {
			orgId, classDatas:classObjs
		}
		await postData("schoolApi/batchInsertClasses", obj, navigate); 
		//await new Promise(resolve => setTimeout(resolve, 5000));
		
		fetchClassData();
		setClassNameStr("");
		setClassObjs([]);
		setLoadingLock(false);
	}
	
	return (<div style={{borderBottom:"1px solid #a58258", display:"flex", padding:"0 0 10px 0", flexDirection:"column", gap:"5px"}}>	
		<div className={s.paramHolder}>
			
			<div style={{fontWeight:"bold", fontSize:"22px"}}>Batch Create Class</div>
			<div className={s.newLabel} style={{overflowWrap: "break-word"}}>{errorMessage}</div>
			<textarea style={{border:"1px solid #22222222", width:"50%"}}  
				className={s.textAreaAuto} value={classNameStr} rows={10} wrap='off' onChange={(e) => setClassNameStr(e.target.value)}/>
		</div>
		
		<div style={{display:"flex", justifyContent:"center", gap:"10px"}}>
			<BlueButton isEnabled={classNameStr}
				clickedAction={()=>{
					sortRemoveDup()
				}} bText="Sort & remove duplicate" />
			<GreenButton isEnabled={classNameStr}
				clickedAction={()=>{
					loadClassData()
				}} bText="Load Class" />
		</div>
		<div className={s.paramHolder} style={{marginBottom:0, width:"100%", textAlign:"left"}}  >	
			<div style={{display:"flex"}}>
				<div style={{flex:"0 0 100px"}}>id</div>
				<div style={{flex:"0 0 150px"}}>name</div>
				<div style={{flex:"0 0 100px"}}>label</div>
				<div style={{flex:"0 0 150px"}}>level</div>
			</div>
		</div>
		<div className={s.paramHolder} style={{marginTop:0, width:"100%", textAlign:"left"}}  >	
			{classObjs.map((c, indexC)=> (<div style={{display:"flex", alignItems:"center"}}>
				<div style={{flex:"0 0 100px"}}>{c.id}
					{(!c.id) && (<span className={s.newLabel}>new</span>)}
				
				</div>
				<div style={{flex:"0 0 150px"}}>{c.name}</div>
				<div style={{flex:"0 0 100px"}}>{c.label}</div>
				<input className={s.inputBox} type="text" value={c.level} 
					onChange={(e)=>{
						classObjs[indexC].level = e.target.value;
						setClassObjs([...classObjs]);
					}}
				/>
			</div>))}
			</div>
			
		<div style={{display:"flex", justifyContent:"center", gap:"10px"}}>
			<GreenButton isEnabled={errorMessage == "" && classObjs.length > 0 && !loadingLock}
				clickedAction={()=>{
					setLoadingLock(true);
					batchInsertClasses()
				}} bText="Submit" />
		</div>
	</div>)

}

export default function SchoolClass(prop) {	
	const navigate = useNavigate();
	let schoolId = prop.schoolId;
	let eduLv = prop.eduLv;
	let currentYearRange = prop.currentYearRange;
	
	const [classes, setClasses] = useState([]);
	const [showDetail, setShowDetail] = useState([]);
	const [detail, setDetail] = useState([]);
	
	const [newClassName, setNewClassName] =  useState("");
	const [bindUserId, setBindUserId] =  useState("");
	const [bindClassId, setBindClassId] =  useState("");
	const [deleteModeEnable, setDeleteModeEnable] =  useState(false);
	const [updateBasicModeEnable, setUpdateBasicModeEnable] =  useState(false);
	const [createClassModeEnable, setCreateClassModeEnable] =  useState(false);
	const [batchCreateClassModeEnable, setBatchCreateClassModeEnable] =  useState(false);
	const [batchBindUsersToClassesModeEnable, setBatchBindUsersToClassesModeEnable] =  useState(false);
	const [giveOutMoneyModeEnable, setGiveOutMoneyModeEnable] = useState(false);
	const [assignLimitEnable, setAssignLimitEnable] = useState(false);
	const [moveClassEnable, setMoveClassEnable] = useState(false);
	
	const [classUserRemoveList, setClassUserRemoveList] = useState([]);

	const fetchData = async () => {
		let res = await getData('schoolApi/listClassesBySchoolId?id=' + schoolId, navigate);
		let cs = res.data;
		
		cs.forEach((c, cIndex) => {
			let json = JSON.parse(c.json)
			let plan = json['plan'];
			c.cReadingLimit = 0;
			c.cLongReadingLimit = 0;
			c.cListeningLimit = 0;
			c.cSpeakingLimit = 0;
			c.cWordBankLimit = 0;
			c.cTeachingNoteLimit = 0;
			c.cIdeaLimit = 0;
			c.cGrammarLimit = 0;
			c.cVipWritingLimit = 0;
			
			plan.forEach((p, pIndex) => {
				switch (p['type']){
					case "key-reading": c.cReadingLimit++;break;
					case "key-long-reading": c.cLongReadingLimit++;break;
					case "key-listening": c.cListeningLimit++;break;
					case "key-speaking": c.cSpeakingLimit++;break;
					case "key-word-bank": c.cWordBankLimit++;break;
					case "key-teaching-note": c.cTeachingNoteLimit++;break;
					case "key-idea": c.cIdeaLimit++;break;
					case "key-grammar": c.cGrammarLimit++;break;
					case "key-vip-writing": c.cVipWritingLimit++;break;
				}
			});
		});
		
		setClasses(cs);
		if (cs && cs[0] && cs[0].id) {
			setBindClassId(cs[0].id);
		}
	}
	
	const fetchDetail = async (classId) => {
		let res = await getData('schoolApi/listStudentsByClassId?id=' + classId, navigate);
		detail[classId] = res.data;
		setDetail({...detail});
		
	}
	
	useEffect(() => {
		fetchData();
	}, []);
	
	const createNewClassName = async() => {
		let obj = { orgId:schoolId, name:newClassName }
		
		await postData("schoolApi/createClass", obj, navigate); 
		fetchData();		
	}
	
	
	const updateClassData = async(id, level, name, label) => {
		let obj = { classId:id, level, name, label }
		
		await postData("schoolApi/updateClassData", obj, navigate); 	
	}
	
	const bindUserToClass = async() => {
		setBindUserId("");
		let obj = { orgId:schoolId, classId:bindClassId, userId:bindUserId }
		await postData("schoolApi/bindUserToClass", obj, navigate); 
		fetchDetail(bindClassId);
	}
	
	const removeUserFromClass = async () => {
		let obj = {
			"classUserRemoveList" : classUserRemoveList			
		}
		await postData("schoolApi/removeUserFromClass", obj, navigate); 
	}
	
	const updateAssignLimit = async (index, key, value) => {		
		classes[index][key] = value;
		setClasses([...classes]);
		
		
		let obj = {
			"cId" : classes[index].id,
			"key" : key,
			"limit" : value,
		}
		
		await postData("schoolApi/updateClassAssignLimit", obj, navigate); 
		
	}
	
	const moveClassToOrg = async (classId, targetOrgId) => {
		let obj = {classId, targetOrgId}
		
		await postData("tutorGroupApi/moveClassToOrganization", obj, navigate); 
		
		fetchData();
	}

	return (<div style={{margin:"20px"}}>
		
		<div className={s.removePanelList + ((classUserRemoveList.length == 0) ? "": " " + s.removePanelListShow)}>
			<div>
				<div>Number of student Remove from class: </div>
				<div style={{fontSize:"2rem"}}>{classUserRemoveList.length}</div>
				
				<div style={{display:"flex", gap:"5px"}}>
					<RedButton overrideStyle={{border:"1px solid #5c1004", background:"#f96f20"}} isEnabled={true}
						clickedAction={async()=> { 
						
							await removeUserFromClass();
						
							let newObj = {}
							const keys = Object.keys(detail);
							for (let i = 0; i < keys.length; i++) {
								const key = keys[i];
								let userDatas = [];
								
								for (let j=0; j< detail[key].length; j++) {
									if (detail[key][j].removeFromClass == true) {
										
									} else {
										userDatas.push({...detail[key][j]});
									}
								}
								newObj[key] = userDatas;
							}
							setDetail({...newObj});
						
							setClassUserRemoveList([]);
						}} bText="Remove ALL!" />
					<BlueButton overrideStyle={{border:"1px solid #193f70", background:"#3ed5d9"}} isEnabled={true}
						clickedAction={()=>{ 
							setClassUserRemoveList([]);
							
							let newObj = {}
							const keys = Object.keys(detail);
							for (let i = 0; i < keys.length; i++) {
								const key = keys[i];
								let userDatas = [];
								
								for (let j=0; j< detail[key].length; j++) {
									
									detail[key][j].removeFromClass = false;
									userDatas.push({...detail[key][j]});
								}
								newObj[key] = userDatas;
							}
							setDetail({...newObj});
						}} bText="Clear" />
				</div>
			</div>
			
		</div>
		
		
		<div className={s.paramHolder} style={{display:"flex", alignItems:"center", gap:"10px", padding:"5px", flexWrap:"wrap"}}>
			<div className={s.nonClickableTitle} >Mode:</div>
			<MyPressButton isPressed={createClassModeEnable} clickedAction={()=>{setCreateClassModeEnable(p=>!p)}} bText="Create Class"/>
			<MyPressButton isPressed={batchCreateClassModeEnable} clickedAction={()=>{setBatchCreateClassModeEnable(p=>!p)}} bText="Batch Create Classes"/>
			<MyPressButton isPressed={batchBindUsersToClassesModeEnable} clickedAction={()=>{setBatchBindUsersToClassesModeEnable(p=>!p)}} bText="Bind Users to Classes"/>
			
			<MyPressButton isPressed={deleteModeEnable} clickedAction={()=>{setDeleteModeEnable(p=>!p)}} bText="Remove User"/>
			<MyPressButton isPressed={updateBasicModeEnable} clickedAction={()=>{setUpdateBasicModeEnable(p=>!p)}} bText="Update Basic"/>
			
			<MyPressButton isPressed={giveOutMoneyModeEnable} clickedAction={()=>{setGiveOutMoneyModeEnable(p=>!p)}} bText="Give out $$"/>
			<MyPressButton isPressed={assignLimitEnable} clickedAction={()=>{setAssignLimitEnable(p=>!p)}} bText="Assign Limit"/>
			<MyPressButton isPressed={moveClassEnable} clickedAction={()=>{setMoveClassEnable(p=>!p)}} bText="move class"/>
			
		</div>
		{
			
		(batchCreateClassModeEnable) && (<div className={s.paramHolder}>
			
		<BatchCreateClass orgId={schoolId} currentYearRange={currentYearRange} fetchClassData = {()=>fetchData()}/>
		</div>)
			
		}
		{
			(giveOutMoneyModeEnable) && (<div className={s.paramHolder}>
				<GiveOutMoney orgId={schoolId}/>
			</div>)
		}
		{
			
		(batchBindUsersToClassesModeEnable) && (<div className={s.paramHolder}>
			
		<BatchBindUsersToClasses orgId={schoolId} fetchClassData = {()=>fetchData()} showDetail={showDetail} fetchClassDetailData={(classId)=>fetchDetail(classId)}/>
		</div>)
			
		}
		{
			(createClassModeEnable) && 
		(<div className={s.paramHolder}>
			
			<div style={{display:"flex"}}>
				<div style={{display:"flex", padding:"10px 0 0 0"}}>
					<div className={s.nonClickableTitle} style={{width:"120px"}}>
						<span>New Class</span>
					</div>
					<div style={{fontWeight:"bold"}}>:</div>		
				</div>
				<div className={s.itemHolder}>
					<input value={newClassName} style={{width:"200px"}} onChange={(e)=>{
						setNewClassName(e.target.value);
					}} />
					<div className={(newClassName) ? s.btnActive : s.btnInactive} onClick={createNewClassName}>
						create
					</div>
				</div>
			</div>
			
			<div style={{display:"flex", alignItems:"center", flexWrap:"wrap"}}>
				<div style={{display:"flex"}}>
					<div className={s.nonClickableTitle} style={{width:"120px"}}>
						<span>Bind User</span>
					</div>
					<div style={{fontWeight:"bold"}}>:</div>		
				</div>
				<div className={s.itemHolder}>
					<input value={bindUserId} style={{width:"200px"}} onChange={(e)=>{
						setBindUserId(e.target.value);
					}} />
				</div>
				<div style={{display:"flex"}}>
					<div className={s.nonClickableTitle} style={{width:"120px"}}>
						<span>to Class</span>
					</div>
					<div style={{fontWeight:"bold"}}>:</div>		
				</div>
				<div style={{display:"flex", padding:"5px"}}>
				
					<select className={s.selectorStyle} value={bindClassId} onChange={
						(e)=>{
							setBindClassId(e.target.value)
						}}>
						{
							classes.map((c, indexC) => (<option key={'classOption' + indexC} value={c.id}>
								{c.id} - {c.name}
							</option>))
						}
					</select>
				
				</div>
				<div>
					<div className={(bindUserId) ? s.btnActive : s.btnInactive} onClick={bindUserToClass}>
						bind
					</div>
				</div>
				<div style={{fontSize:"12px"}}>
					* bind user to a class will put the user into the target organization
				</div>
			</div>
		</div>)
	
}
		{
			classes.map((c, indexC) => {
				return (
				<div key={"classes" + indexC} className={s.studentHolder} style={(indexC % 2 == 0) ? {background:"#d8e7f2", margin:"10px 0"} : {background:"#ebc5b9", margin:"10px 0"}}>
				
					<div style={{display:"flex", alignItems:"center", textAlign:"left", justifyContent:"start", background:"white", padding:"2px", margin:"2px", gap:"5px"}}>
						
						{/*
						<div style={{width:"60px"}} className={s.btnLitActive} onClick={()=>{
							if (!showDetail[c.id]) {
								showDetail[c.id] = [];
							}
							showDetail[c.id][indexC] = (showDetail[c.id][indexC]) ? !showDetail[c.id][indexC] : true;
							setShowDetail({...showDetail})
							
							fetchDetail(c.id);
						}}>
							show
			</div>*/}
						<div>
						<MyGreenPressButton isPressed={(showDetail[c.id])} clickedAction={()=>{

							showDetail[c.id] = (showDetail[c.id]) ? !showDetail[c.id]: true;
							setShowDetail({...showDetail})
							
							fetchDetail(c.id);
						}} bText="Show"/>
						</div>
						
						
						
						
						<div style={{display:"flex", gap:"5px", flexWrap:"wrap"}}>
							<div>Class Id:</div>
							<div style={{fontWeight:"bold"}}>{c.id}</div>
							<div>TG Id:</div>
							<div style={{fontWeight:"bold"}}>{c.tutorGroupId}</div>
							
							<div>Label:</div>
							
							{
								(!updateBasicModeEnable) && (<div style={{fontWeight:"bold"}}>{c.label}</div>)
							}
							{
								
								(updateBasicModeEnable) && (<input className={s.smallInputBox} type="text" value={c.label} 
									onChange={(e)=>{
										classes[indexC].label = e.target.value;
										setClasses([...classes]);
									}}
								/>)
							}
							
							
							<div>Level:</div>
							{
								(!updateBasicModeEnable) && (<div style={{fontWeight:"bold"}}>{c.level}</div>)
							}
							{
								
								(updateBasicModeEnable) && (<input className={s.smallInputBox} type="text" value={c.level} 
									onChange={(e)=>{
										classes[indexC].level = e.target.value;
										setClasses([...classes]);
									}}
								/>)
							}

							
							<div>Name:</div>
							
							{
								(!updateBasicModeEnable) && (<div style={{fontWeight:"bold"}}>{c.name}</div>)
							}
							{
								
								(updateBasicModeEnable) && (<input className={s.smallInputBox} type="text" value={c.name} 
									onChange={(e)=>{
										classes[indexC].name = e.target.value;
										setClasses([...classes]);
									}}
								/>)
							}
							
							{
								(moveClassEnable) && (<div style={{display:"flex", justifyContent:"center"}}>								
									<BlueButton isEnabled={true} overrideStyle={{padding:"0 2px", margin:"2px", borderRadius:"2px"}} 
										clickedAction={()=>{moveClassToOrg(c.id, 371) }} 
										bText="To 371" />
									<BlueButton isEnabled={true} overrideStyle={{padding:"0 2px", margin:"2px", borderRadius:"2px"}} 
										clickedAction={()=>{moveClassToOrg(c.id, 394)}} 
										bText="To 394" />
								</div>)
							}
							
						</div>
						<div style={{margin:"0 5px 0 auto"}}>
							
							
							
					
					
							
							
							
							
							
							
							
							
							{
								(!updateBasicModeEnable) && (<GreenButton isEnabled={true} overrideStyle={{padding:"2px 5px",  borderRadius:"2px"}} 
								clickedAction={()=>{ 
									
									unsecuredCopyToClipboard(detail[c.id].filter(item => item.userGroup == 5).map(item => item.id).join(',')); 
								}} bText="Copy Student Ids" />)
							}
							{
								(updateBasicModeEnable) && (<GreenButton isEnabled={true} overrideStyle={{padding:"2px 5px",  borderRadius:"2px"}} 
								clickedAction={()=>{ 
									updateClassData(c.id, c.level, c.name, c.label);
									
								}} bText="Update" />)
							}
							
						</div>
					</div>
					{
					(assignLimitEnable) &&(<div className={s.limitHolder}>
						<div style={{fontWeight:"bold", margin: "0", color:"#6f8570"}}>Assign Limit</div>
						{
							classLimitConst.map((clc, clcIndex)=>(<div className={s.limitInputBoxOverallHolder}
								 style={{border:(c[clc.cLimitKey] > 0) ? "2px solid #ffe730" : "2px solid #5c735d"}}
								>
								<div className={s.limitInputBoxLabel}>{clc.name}</div>
								<div className={(c[clc.cLimitKey] > 0) ? s.limitAmtEnable : s.limitAmt} style={{paddingLeft:"10px", fontWeight:"bold"}}>{c[clc.cLimitKey]}</div> 
								<div style={{color:"#42503e"}}>/</div> 
								<div className={s.limitInputBoxHolder}>
									<input className={s.limitInputBox} type="text" value={c[clc.key]} 
										style={{width:'100px'}}
										onChange={(e)=>{
											let v = parseInt(e.target.value)
											if (Number.isInteger(v)) {
												if (v >= 100000) {
													v = 99999;
												}
												
												updateAssignLimit(indexC, clc.key, v);
											}
										}}
									/>
								</div>
								
							</div>)
							
						)}
						
						
						
					</div>)
					}
					
					
					
					
					
					{
						(showDetail[c.id]) && (<div>
				
							<div style={{display:"flex", gap:"10px", margin:"0 10px",textAlign:"left", color:(indexC % 2 == 0) ? "#465f63" : "#704335", fontWeight:"bold", minWidth:"1000px"}}>
								{(deleteModeEnable) && (<div style={{flex: "0 0 35px", paddingLeft:"5px", color:"red"}}>D</div>)}
								<div style={{flex: "0 0 100px"}}>id</div>
								<div style={{flex: "0 0 300px"}}>username</div>
								<div style={{flex: "0 0 300px"}}>nickname</div>
								<div style={{width:'100px'}}>Start Date</div>
								<div style={{width:'100px'}}>End Date</div>
							</div>
						
							{
								(detail[c.id] && detail[c.id].length > 0) && (<div style={{background:"white"}}>
									{
										detail[c.id].map((stu, indexS) => (<div key={"stuDetail" + indexS} className={s.studentUserRow} style={{alignItems:"center", gap:"10px"}}>
											
											{(deleteModeEnable) &&
											(<div style={{flex: "0 0 35px",textAlign:"left", display:"flex"}} >
											<CheckboxSmall label={""} isChecked = {((stu.removeFromClass == true) ? true : false)} changeAction={()=>{
												let removeFromClass = (stu.removeFromClass == true) ? true : false;
												
												detail[c.id][indexS].removeFromClass = !removeFromClass;
												
												let obj = {
													'cId':c.id,
													'uId':stu.id
												};
												if (removeFromClass) {
													setClassUserRemoveList([...classUserRemoveList.filter((r) => (r.cId != c.id || r.uId != stu.id))]);
												} else {
													classUserRemoveList.push(obj);
													setClassUserRemoveList([...classUserRemoveList]);
												}
												setDetail({...detail});
											}}
									/></div>) }
											
											
											<div style={{flex: "0 0 100px",textAlign:"left"}} onClick={()=>{ unsecuredCopyToClipboard(stu.id)}}>{stu.id}</div>
											<div style={{flex: "0 0 300px",textAlign:"left"}} onClick={()=>{ unsecuredCopyToClipboard(stu.username)}}>({getUserGroupName(stu.userGroup)})
												{stu.username}
											</div>
											<div style={{flex: "0 0 300px",textAlign:"left", display:"flex", gap:"2px"}}>
												<BlueButton isEnabled={(stu.accessToken)} overrideStyle={{padding:"0 2px", margin:"2px", borderRadius:"2px"}} clickedAction={()=>{ unsecuredCopyToClipboard(stu.accessToken); }} bText="Copy AT" />
												{stu.nickname}
											</div>
											<DateRange stuId={stu.id} tutorGroupId={c.tutorGroupId} iUStartDate={stu.uStartDate} iUEndDate={stu.uEndDate}/>
											
										</div>))
									}
								</div>)
							}
						</div>)
					}
					
				</div>)
			})
		}
	</div>)
	
}

const DateRange = ({stuId, tutorGroupId, iUStartDate, iUEndDate}) => {
	const navigate = useNavigate();
	const [uStartDate, setUStartDate] = useState(iUStartDate);
	const [uEndDate, setUEndDate] = useState(iUEndDate);
	const updateTutorGroupUserDateRange = async (stuId, tutorGroupId, uStartDate, uEndDate) => {
		if (!uStartDate || !uEndDate) {
			return;
		}
		
		let obj = {
			"userId" : stuId,
			tutorGroupId,
			uStartDate,
			uEndDate
		}
		await postData("tutorGroupApi/updateTutorGroupUserDateRange", obj, navigate); 
	}

	const clearTutorGroupUserDateRange = async (stuId, tutorGroupId) => {
		let obj = {
			"userId" : stuId,
			tutorGroupId
		}
		
		await postData("tutorGroupApi/clearTutorGroupUserDateRange", obj, navigate); 
	}
	
	return (<>
		<div>
			<input className={s.smallInputBox} type="text" value={uStartDate} 
				placeholder="yyyy-mm-dd"
				style={{width:'100px'}}
				onChange={(e)=>{
					setUStartDate(e.target.value);
				}}
			/>
		</div>
		
		<div>
			<input className={s.smallInputBox} type="text" value={uEndDate} 
				placeholder="yyyy-mm-dd"
				style={{width:'100px'}}
				onChange={(e)=>{
					setUEndDate(e.target.value);
				}}
			/>
		</div>
		<div>
			<BlueButton isEnabled={true} overrideStyle={{padding:"0 2px", margin:"2px", borderRadius:"2px"}} 
				clickedAction={()=>{ 
					updateTutorGroupUserDateRange(stuId, tutorGroupId, uStartDate, uEndDate)
				}} bText="Update" />
		</div>
		<div>
			<BlueButton isEnabled={true} overrideStyle={{padding:"0 2px", margin:"2px", borderRadius:"2px"}} 
				clickedAction={()=>{ 
					setUStartDate("");
					setUEndDate("");
					
					clearTutorGroupUserDateRange(stuId, tutorGroupId)
				}} bText="Clear" />
		</div>
	</>)

}


const getUserGroupName = (userGroup) => {
	switch(userGroup) {
		case 3:
			return "Teacher";
		case 5:
			return "Student";
	}
}

const classLimitConst = [
	{"name":"Reading","key":"readingLimit", "cLimitKey":"cReadingLimit"},
	{"name":"Long Reading","key":"longReadingLimit", "cLimitKey":"cLongReadingLimit"},
	{"name":"Listening","key":"listeningLimit", "cLimitKey":"cListeningLimit"},
	{"name":"Speaking","key":"speakingLimit", "cLimitKey":"cSpeakingLimit"},
	{"name":"Word Bank","key":"wordBankLimit", "cLimitKey":"cWordBankLimit"},
	{"name":"Teaching Note","key":"teachingNoteLimit", "cLimitKey":"cTeachingNoteLimit"},
	{"name":"Idea","key":"ideaLimit", "cLimitKey":"cIdeaLimit"},
	{"name":"Grammar","key":"grammarLimit", "cLimitKey":"cGrammarLimit"},
	{"name":"VIP writing","key":"vipWritingLimit", "cLimitKey":"cVipWritingLimit"},
]